import { t } from '@lingui/macro';
import { Alert } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function FailedDataRetrievalAlert() {
    return (<Alert appearance="danger" icon={<Falcon icon="exclamation-triangle"/>} message={t({
            message: 'An error occured while fetching the attachments. Please try again later.',
            comment: 'Message when an error occured while fetching the sign request attachments',
        })}/>);
}
